import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { reportRouteChange } from "@/utils/telemetry";

/**
 * Componente layout-only: reporta cada cambio de pathname al backend
 * de telemetría. Montado como ruta padre dentro de createBrowserRouter.
 */
export function TelemetryRouteTracker() {
  const location = useLocation();
  useEffect(() => {
    reportRouteChange(location.pathname + location.search);
  }, [location.pathname, location.search]);
  return <Outlet />;
}
